module.exports = __webpack_public_path__ + "img/card_ip_stipulation51.e20a278b.svg";